var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle))])]),_c('el-col',{attrs:{"span":6}},[_vm._t("button")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }